import { RouteObject } from "react-router-dom";
import ProtectedOutlet from "components/ProtectedOutlet";
import { ClaimResource } from "types/claimTypes";

import { ImportsStatusPage } from "pages/ImportsPage/ImportsStatusPage";
import ImportsUploadForm from "pages/ImportsPage/ImportsUploadForm";
import ImportsColumnMappingPage from "pages/ImportsPage/ImportsColumnMappingPage";
import ImportsProcessPage from "pages/ImportsPage/ImportsProcessPage";
import { ImportsSummary } from "pages/ImportsPage/ImportsSummary";

import RequestsList from "pages/RequestsPage/RequestsList";
import TestDataGenerationCreateForm from "pages/TestDataGeneration/TestDataGenerationCreateForm";
import ProcessesList from "pages/ProcessesPage/ProcessesList";
import HealthCheckPage from "pages/HealthCheckPage";

import EmailsList from "pages/EmailsPage/EmailsList";
import EmailDetails from "pages/EmailsPage/EmailDetails";

import OperationsPage from "pages/OperationsPage";
import E2eRegressionTestsPage from "pages/E2eRegressionTestsPage";
import DeveloperDashboardPage from "pages/DeveloperDashboardPage";
import WebhooksList from "pages/WebhooksPage/WebhooksList";
import DataToolsList from "pages/DataToolsPage/DataToolsList";
import DataToolRunPage from "pages/DataToolsPage/DataToolRunPage";
import ScriptRunnerList from "pages/ScriptRunnerPage/ScriptRunnerList";

export const operationsRoutes: RouteObject[] = [
  {
    element: <ProtectedOutlet claims={[ClaimResource.Imports]} />,
    children: [
      { path: "imports", element: <ImportsStatusPage /> },
      { path: "imports/new", element: <ImportsUploadForm /> },
      { path: "imports/:id/mapping", element: <ImportsColumnMappingPage /> },
      { path: "imports/:id/process/:dateString", element: <ImportsProcessPage /> },
      { path: "imports/summary/:jobId", element: <ImportsSummary /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Requests]} />,
    children: [
      { path: "requests", element: <RequestsList /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.TestDataGeneration]} />,
    children: [
      { path: "test-data-generation", element: <TestDataGenerationCreateForm /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Processes]} />,
    children: [
      { path: "processes", element: <ProcessesList /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Emails]} />,
    children: [
      { path: "emails", element: <EmailsList /> },
      { path: "emails/:emailId", element: <EmailDetails /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.E2eRegressionTests]} />,
    children: [
      { path: "e2e-regression-tests", element: <E2eRegressionTestsPage /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.DeveloperDashboard]} />,
    children: [
      { path: "developer-dashboard", element: <DeveloperDashboardPage /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.Webhooks]} />,
    children: [
      { path: "webhooks", element: <WebhooksList /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.DataTools]} />,
    children: [
      { path: "data-tools", element: <DataToolsList /> },
      { path: "data-tools/:runId", element: <DataToolRunPage /> },
      { path: "script-runner", element: <ScriptRunnerList /> },
    ],
  },
  { path: "health-check", element: <HealthCheckPage /> },
  { index: true, element: <OperationsPage /> },
];
